import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SessionInfo, PlayerInfo } from "../../common/Info";
import { startGame, gameEnded } from "./gameSlice";

type endGameDislay = {
  players: PlayerInfo[];
  endReasons: string[];
};

const initialState: endGameDislay = {
  players: [],
  endReasons: [],
};

const endGameLeaderboardSlice = createSlice({
  name: "endGameLeaderboard",
  initialState,
  reducers: {
    setEndGameLeaderboard(state, action: PayloadAction<SessionInfo>) {
      state.players = action.payload.players.sort(
        (a: PlayerInfo, b: PlayerInfo) => b.score - a.score,
      );
      if (action.payload.game && action.payload.game.endReasons) {
        state.endReasons = action.payload.game.endReasons;
      } else {
        state.endReasons = [];
      }
    },
  },
  extraReducers(builder) {
    builder.addCase(gameEnded, (state, action: PayloadAction<SessionInfo>) => {
      state.players = action.payload.players.sort(
        (a: PlayerInfo, b: PlayerInfo) => b.score - a.score,
      );
      if (action.payload.game && action.payload.game.endReasons) {
        state.endReasons = action.payload.game.endReasons;
      } else {
        state.endReasons = [];
      }
    });
    builder.addCase(startGame, (state, action: PayloadAction<SessionInfo>) => {
      return initialState;
    });
  },
});

export const { setEndGameLeaderboard } = endGameLeaderboardSlice.actions;
export const endGameLeaderboardReducer = endGameLeaderboardSlice.reducer;
